import MAYA from "../../../maya_api";
import {setLoadingContent} from "../../../layouts/Content/modules/loadingContent";
import {PAYMENT_STATUS, RECEIPT_STATUS} from '../../../constants'
import {N} from "../../../helpers";

// ------------------------------------
// Constants
// ------------------------------------

const LOAD_SHOPPING_CART = 'LOAD_SHOPPING_CART';
const SELECT_PAYMENT = 'SELECT_PAYMENT';
const SELECT_ALL_PAYMENTS = 'SELECT_ALL_PAYMENTS';
const REMOVE_PAYMENT = 'REMOVE_PAYMENT';
const START_PAY_PAYMENTS = 'START_PAY_PAYMENTS';
const UPDATE_RECEIVED_AMOUNT = 'UPDATE_RECEIVED_AMOUNT';
const SELECT_PAYMENT_ON_DELETE = 'SELECT_PAYMENT_ON_DELETE';
const CHANGE_PAYMENT_STATUS = 'CHANGE_PAYMENT_STATUS';
const PRINT_RECEIPT = 'PRINT_RECEIPT';
const UPDATE_COMMON_RECEIPT = 'UPDATE_COMMON_RECEIPT';


// ------------------------------------
// Actions
// ------------------------------------
function loadProducts() {
  return async (dispatch, getStore) => {

    let currentPayments = getStore().cart.payments;

    currentPayments = _.filter(currentPayments, (p) => p.payment_status === PAYMENT_STATUS.PAYMENT_WAIT_PROCESSING);

    await dispatch(setLoadingContent(true));

    let result = await MAYA.loadShoppingCart();

    if(!result) result = [];

    await dispatch(setLoadingContent(false));

    const diffs = _.differenceBy(result.payments, currentPayments, 'payment_id') || [];

    result = currentPayments.length ? _.concat(currentPayments, diffs) : result.payments;

    dispatch({
      type    : LOAD_SHOPPING_CART,
      payload : result
    });
  };
}

function selectPayment(value, forceValue) {
  return (dispatch, getStore) => {

    let payments = getStore().cart.payments;

    let filteredPayments = _.filter(payments, (p) => p.payment_status === PAYMENT_STATUS.PAYMENT_WAIT_PROCESSING);

    let payment = _.find(filteredPayments, (p) => p.payment_id === value);

    if(payment){
      payment = _.extend(payment, {payment_selected: forceValue === undefined ? !payment.payment_selected : forceValue});

      payments = _.unionWith(payments, [payment], {payment_id: value});
    }

    dispatch({
      type    : SELECT_PAYMENT,
      payload : payments
    })
  }
}

function selectAllPayments() {
  return (dispatch, getStore) => {
    let payments = getStore().cart.payments;

    let filteredPayments = _.filter(payments, (p) => p.payment_status === PAYMENT_STATUS.PAYMENT_WAIT_PROCESSING);

    const hasUnselected = _.find(filteredPayments, (p) => !p.payment_selected);

    if(hasUnselected){
      _.map(filteredPayments, (p) => _.extend(p, {payment_selected : true}))
    } else {
      _.map(filteredPayments, (p) => _.extend(p, {payment_selected : false}))
    }

    payments = _.unionBy(payments, filteredPayments, 'payment_id');

    dispatch({
      type    : SELECT_PAYMENT,
      payload : payments
    })
  }
}

function removePayment(value) {
  return async (dispatch, getStore) => {
    let payments = getStore().cart.payments;

    const result = await MAYA.removePayment(value);

    if(result){
      let payment = _.find(payments, (p) => p.payment_id === value);
      if(!payment) return payments;

      payments = _.pullAllBy(payments, [{payment_id: value}], 'payment_id');
    }

    dispatch({
      type    : REMOVE_PAYMENT,
      payload : payments
    });
  };
}

function startPayPayments() {
  return (dispatch, getStore) => {
    const payments = getStore().cart.payments;
    const receivedAmount = getStore().cart.received_amount;

    const payment_ids = _.map((_.filter(payments, (p) => p.payment_selected &&
      p.payment_status === PAYMENT_STATUS.PAYMENT_WAIT_PROCESSING) || [false]), 'payment_id');

    dispatch({
      type    : START_PAY_PAYMENTS,
      payload : payments
    });

    MAYA.payPayments(payment_ids, N(receivedAmount));
  };
}

function updateReceivedAmount(value = '') {
  return {
    type    : UPDATE_RECEIVED_AMOUNT,
    payload : value
  }
}

function selectPaymentOnDelete(value = 0) {
  return {
    type    : SELECT_PAYMENT_ON_DELETE,
    payload : value
  }
}

function updatePaymentStatus(payment_id, status, data = {}) {
  return function (dispatch, getStore) {
    let payments = getStore().cart.payments;

    payments = _.map(payments, (p) => {
      if(p.payment_id === payment_id){
        p.payment_status = status;
        p = _.extend(p, data);
      }

      return p;
    });

    dispatch({
      type: CHANGE_PAYMENT_STATUS,
      payload: payments
    })
  }
}

function printReceipt(value) {
  return function(dispatch, getStore) {
    MAYA.printReceipt(value, () => {
      dispatch(setLoadingContent(true))
    }, () => {
      dispatch(setLoadingContent(false))
    });

    dispatch({
      type: PRINT_RECEIPT
    })
  }
}

function updateCommonReceipt(receipt_status = '', receipt_url = '') {
  return {
    type: UPDATE_COMMON_RECEIPT,
    payload: {receipt_status, receipt_url}
  }
}


export {
  loadProducts,
  selectPayment,
  selectAllPayments,
  removePayment,
  startPayPayments,
  updateReceivedAmount,
  selectPaymentOnDelete,
  updatePaymentStatus,
  printReceipt,
  updateCommonReceipt
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [LOAD_SHOPPING_CART]: (state, action) => updatePayments(state, action),
  [SELECT_PAYMENT]: (state, action) => updatePayments(state, action),
  [SELECT_ALL_PAYMENTS]: (state, action) => updatePayments(state, action),
  [REMOVE_PAYMENT]: (state, action) => ({
    ...state,
    payments: action.payload,
    payment_on_delete: 0
  }),
  [START_PAY_PAYMENTS]: (state, action) => ({
    ...state,
    payments: action.payload,
    received_amount: '',
    receipt_status: '',
    receipt_url: ''
  }),
  [UPDATE_RECEIVED_AMOUNT]: (state, action) => ({
    ...state,
    received_amount: action.payload
  }),
  [SELECT_PAYMENT_ON_DELETE]: (state, action) => ({
    ...state,
    payment_on_delete: action.payload
  }),
  [CHANGE_PAYMENT_STATUS]: (state, action) => updatePayments(state, action),
  [PRINT_RECEIPT]: (state, action) => state,
  [UPDATE_COMMON_RECEIPT]: (state, action) => ({
    ...state,
    ...action.payload
  })
};

function updatePayments(state, action){
  return {
    ...state,
    payments: action.payload
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  payments: [
    // {
    //   payment_unselected: false,
    //   payment_status: [CONSTANT STRING],
    // }
  ],
  received_amount: '',
  payment_on_delete: 0,
  receipt_status: RECEIPT_STATUS.RECEIPT_WAIT_PROCESSING,
  receipt_url: ''
};

export default function shoppingCartReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}





// WEBPACK FOOTER //
// ./src/components/ShoppingCart/modules/shoppingCart.js